var map = {
	"./custom/128px/DHW.svg": 505,
	"./custom/128px/budget-control-error.svg": 506,
	"./custom/128px/budget-control.svg": 507,
	"./custom/128px/error.svg": 508,
	"./custom/128px/spaceheating.svg": 509,
	"./custom/176px/no-internet.svg": 510,
	"./custom/200px/house-base.svg": 511,
	"./custom/200px/house-solar-panels.svg": 512,
	"./custom/240px/house.svg": 513,
	"./custom/24px/arrow-backward.svg": 514,
	"./custom/24px/arrow-forward.svg": 515,
	"./custom/29px/ios-camera.svg": 516,
	"./custom/29px/ios-daikin.svg": 517,
	"./custom/29px/ios-privacy.svg": 518,
	"./custom/29px/ios-settings.svg": 519,
	"./custom/40px/add.svg": 520,
	"./custom/40px/pv-optimisation.svg": 521,
	"./custom/48px/unit-boiler-active.svg": 522,
	"./custom/48px/unit-boiler.svg": 523,
	"./custom/48px/unit-gateway-active.svg": 524,
	"./custom/48px/unit-gateway.svg": 525,
	"./custom/48px/unit-indoor-active.svg": 526,
	"./custom/48px/unit-indoor.svg": 527,
	"./custom/48px/unit-outdoor-active.svg": 528,
	"./custom/48px/unit-outdoor.svg": 529,
	"./custom/48px/unit-solarpump-active.svg": 530,
	"./custom/48px/unit-solarpump.svg": 531,
	"./custom/48px/unit-tank-active.svg": 532,
	"./custom/48px/unit-tank.svg": 533,
	"./custom/48px/unit-wlanadapter-active.svg": 534,
	"./custom/48px/unit-wlanadapter.svg": 535,
	"./custom/56px/maintenance.svg": 536,
	"./custom/56px/privacy-consent.svg": 537,
	"./custom/56px/schedule-done.svg": 538,
	"./custom/56px/schedule-notyet.svg": 539,
	"./custom/56px/schedule-soon.svg": 540,
	"./custom/56px/schedule-urgent.svg": 541,
	"./custom/56px/solution-unknown.svg": 542,
	"./custom/64px/detached-house-active.svg": 543,
	"./custom/64px/detached-house-inactive.svg": 544,
	"./custom/64px/elebill-active.svg": 545,
	"./custom/64px/elebill-inactive.svg": 546,
	"./custom/64px/gas-active.svg": 547,
	"./custom/64px/gas-inactive.svg": 548,
	"./custom/64px/heatbill-active.svg": 549,
	"./custom/64px/heatbill-inactive.svg": 550,
	"./custom/64px/home-underfloor-active.svg": 551,
	"./custom/64px/home-underfloor-inactive.svg": 552,
	"./custom/64px/mid-detached-house-active.svg": 553,
	"./custom/64px/mid-detached-house-inactive.svg": 554,
	"./custom/64px/newbuild-active.svg": 555,
	"./custom/64px/newbuild-inactive.svg": 556,
	"./custom/64px/nochange-active.svg": 557,
	"./custom/64px/nochange-inactive.svg": 558,
	"./custom/64px/oil-active.svg": 559,
	"./custom/64px/oil-inactive.svg": 560,
	"./custom/64px/renovated-active.svg": 561,
	"./custom/64px/renovated-inactive.svg": 562,
	"./custom/64px/semi-detached-house-active.svg": 563,
	"./custom/64px/semi-detached-house-inactive.svg": 564,
	"./custom/64px/tariff-active.svg": 565,
	"./custom/64px/tariff-dn-active.svg": 566,
	"./custom/64px/tariff-dn-inactive.svg": 567,
	"./custom/64px/tariff-inactive.svg": 568,
	"./custom/64px/unknown-active.svg": 569,
	"./custom/64px/unknown-inactive.svg": 570,
	"./simple/16px/arrow-down.svg": 571,
	"./simple/16px/arrow-forward.svg": 572,
	"./simple/16px/arrow-up.svg": 573,
	"./simple/16px/delete.svg": 574,
	"./simple/16px/electricity.svg": 575,
	"./simple/16px/euro.svg": 576,
	"./simple/16px/info.svg": 577,
	"./simple/16px/notification.svg": 578,
	"./simple/16px/pound.svg": 579,
	"./simple/16px/questionmark.svg": 580,
	"./simple/16px/remove.svg": 581,
	"./simple/16px/search.svg": 582,
	"./simple/16px/settings.svg": 583,
	"./simple/16px/status-circle.svg": 584,
	"./simple/16px/triangle-down.svg": 585,
	"./simple/16px/triangle-forward.svg": 586,
	"./simple/16px/triangle-up.svg": 587,
	"./simple/24px/app-heatpump.svg": 588,
	"./simple/24px/arrow-back-small.svg": 589,
	"./simple/24px/arrow-right.svg": 590,
	"./simple/24px/big-gear.svg": 591,
	"./simple/24px/big-plus.svg": 592,
	"./simple/24px/check.svg": 593,
	"./simple/24px/checked.svg": 594,
	"./simple/24px/cross.svg": 595,
	"./simple/24px/document.svg": 596,
	"./simple/24px/electricity.svg": 597,
	"./simple/24px/euro.svg": 598,
	"./simple/24px/flip-camera.svg": 599,
	"./simple/24px/grid.svg": 600,
	"./simple/24px/heat.svg": 601,
	"./simple/24px/minus.svg": 602,
	"./simple/24px/plus.svg": 603,
	"./simple/24px/pound.svg": 604,
	"./simple/24px/remove.svg": 605,
	"./simple/24px/setpoint.svg": 606,
	"./simple/24px/solar.svg": 607,
	"./simple/24px/sun.svg": 608,
	"./simple/24px/tocomplete.svg": 609,
	"./simple/24px/unchecked.svg": 610,
	"./simple/260px/placeholder-graph.svg": 611,
	"./simple/26px/alert-off.svg": 612,
	"./simple/26px/alert-on.svg": 613,
	"./simple/32px/alert-on.svg": 614,
	"./simple/32px/app-alwayson.svg": 615,
	"./simple/32px/app-dishwasher.svg": 616,
	"./simple/32px/app-fridge.svg": 617,
	"./simple/32px/app-heatpump.svg": 618,
	"./simple/32px/app-ketle.svg": 619,
	"./simple/32px/app-microwave.svg": 620,
	"./simple/32px/app-others.svg": 621,
	"./simple/32px/app-oven.svg": 622,
	"./simple/32px/app-taoster.svg": 623,
	"./simple/32px/app-tumbledryer.svg": 624,
	"./simple/32px/app-washingmachine.svg": 625,
	"./simple/32px/arrow-back.svg": 626,
	"./simple/32px/arrow-forward.svg": 627,
	"./simple/32px/budget.svg": 628,
	"./simple/32px/checkmark.svg": 629,
	"./simple/32px/energy-saving.svg": 630,
	"./simple/32px/energyprice.svg": 631,
	"./simple/32px/energysetup.svg": 632,
	"./simple/32px/pv-optimisation.svg": 633,
	"./simple/32px/solar.svg": 634,
	"./simple/40px/camera-swap.svg": 635,
	"./simple/40px/torch.svg": 636,
	"./simple/48px/hand-over.svg": 637,
	"./simple/56px/image-failed.svg": 638,
	"./simple/56px/package-cashback.svg": 639,
	"./simple/56px/package-free.svg": 640,
	"./simple/56px/package-maintenance.svg": 641,
	"./simple/56px/package-pom.svg": 642,
	"./simple/64px/app-alwayson.svg": 643,
	"./simple/64px/app-dishwasher.svg": 644,
	"./simple/64px/app-fridge.svg": 645,
	"./simple/64px/app-heatpump.svg": 646,
	"./simple/64px/app-ketle.svg": 647,
	"./simple/64px/app-microwave.svg": 648,
	"./simple/64px/app-others.svg": 649,
	"./simple/64px/app-oven.svg": 650,
	"./simple/64px/app-taoster.svg": 651,
	"./simple/64px/app-tumbledryer.svg": 652,
	"./simple/64px/app-washingmachine.svg": 653,
	"./simple/64px/detached-house-active.svg": 654,
	"./simple/64px/detached-house-inactive.svg": 655,
	"./simple/64px/elebill-active.svg": 656,
	"./simple/64px/elebill-inactive.svg": 657,
	"./simple/64px/gas-active.svg": 658,
	"./simple/64px/gas-inactive.svg": 659,
	"./simple/64px/heatbill-active.svg": 660,
	"./simple/64px/heatbill-inactive.svg": 661,
	"./simple/64px/mid-detached-house-active.svg": 662,
	"./simple/64px/mid-detached-house-inactive.svg": 663,
	"./simple/64px/newbuild-active.svg": 664,
	"./simple/64px/newbuild-inactive.svg": 665,
	"./simple/64px/nochange-active.svg": 666,
	"./simple/64px/nochange-inactive.svg": 667,
	"./simple/64px/oil-active.svg": 668,
	"./simple/64px/oil-inactive.svg": 669,
	"./simple/64px/renovated-active.svg": 670,
	"./simple/64px/renovated-inactive.svg": 671,
	"./simple/64px/semi-detached-house-active.svg": 672,
	"./simple/64px/semi-detached-house-inactive.svg": 673,
	"./simple/64px/tariff-active-copy.svg": 674,
	"./simple/64px/tariff-d-n-copy.svg": 675,
	"./simple/64px/tariff-d-n.svg": 676,
	"./simple/64px/tariff-inactive.svg": 677,
	"./simple/64px/troubleshoot.svg": 678,
	"./simple/64px/unknown-active.svg": 679,
	"./simple/64px/unknown-inactive.svg": 680
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 504;